import { render, staticRenderFns } from "./TemplateReportRsbForm.vue?vue&type=template&id=e550010c&"
import script from "./TemplateReportRsbForm.vue?vue&type=script&lang=js&"
export * from "./TemplateReportRsbForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports